export const Colors = {
    ActiveButton: '#7178FC',
    InactiveButton: '#a9acfd',
    GreenActiveButton: '#26D1B2',
    GreenInActiveButton: '#f1fcfa',
    TextRegionBorder: '#23d7b0',
    TextInputBorder: '#BDBDBD',
    PageBackground: '#BDBDBD',
    GreenBackground: '#f1fcfa',
    Gray: 'gray',
    CustomGray: '#DCDCDC',
    Black: 'black',
    ErrorText: '#8582c9',
    White: 'white',
    SidebarMenuHeader: '#26D1B2',
    SidebarMenuText: '#26D1B2',
    AddressListLeftPanel : '#26D1B2',
    Red: 'red',
    PickerSelectedBorder: '#26D1B2',
    PickerSelectedBackground: '#f1fcfa',
    GreenText: '#26D1B2',
    PurpleText: '#8582c9',
    IntroBorderCOlor: '#e5eced',
    DateIndicatorBackgroundGreen: '#e9faf7',
    DateIndicatorBackgroundPurple: '#f6f6ff',
    IntroStepsColor: '#e5eced',
    GreenBorder: '#26D1B2',
    PurpleBorder: '#7178FC',
    BackgroundColor: '#AEAEAE',
    DatePickerBackground: '#7178FC',
    FetchHourBackground: '#7178FC',
    ChargeBackgrounColor: '#FAFAFA',
    AddressTopicColor: '#e9faf7',
    MessageSystemColor: '#f6f6ff',
    MessageEtcColor: '#e9faf7',
    InvoiceFeeBackground: '#FFFFFF',
    SpinnerColor: '#26D1B2',
    CancelButton: '#ED1C24',
    DefaultBackground:'#e4e3eb',
    PrimaryColor: '#26D1B2',
    SecondaryColor:'#7178FC',
    Peach : 'peach',
    Lilac:  '#c46fb2',
    ColorNew01: "#90e4c4",
    ColorNew02: "#90ace4"
}